export default __webpack_public_path__ + "img/019e225329525ffe5e854a1414305ac1.png";